import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, showMessageToastCustom } from '../../../utils/util';
import { Input, BackButton, Button } from '../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { TitleUI } from '../../../components/UI/LabelTitleUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';

const Reopen = (props) => {
    const [filter, setFilter] = useState(
        {
            mvmNumber: undefined,
            journey: undefined,
            shed: props.sheds.find((i) => i.id === props.user.shed)?.code
        });

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onClick = () => {
        if (!filter.mvmNumber && !filter.journey) {
            return showMessageToastCustom(translate('warning', 'general'), translate('obligatory-fields', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
        props.reopen(filter);
    }


    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="lock_open" label={translate('reopen', 'physical-confirmation')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '21px' }}>
                <div className="container">
                    <div className="card">
                        <ul id='collapsible' className="collapsible">
                            <li className='active'>
                                <div style={{ padding: '10px' }}>
                                    <form id="getReport" className="col s12">
                                        <div className="row">
                                            <div className="input-field padding col s12">

                                                <Input
                                                    id="mvmNumber"
                                                    name='mvmNumber'
                                                    required
                                                    placeholder={translate('mvm', 'physical-confirmation')}
                                                    type="text"
                                                    defaultValue={filter?.mvmNumber || ''}
                                                    onChange={onChange}
                                                />

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="input-field padding col s12">
                                                <Input
                                                    id="journey"
                                                    name='journey'
                                                    placeholder={translate('journey', 'physical-confirmation')}
                                                    type="text"
                                                    defaultValue={filter?.journey || ''}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </li>
                        </ul>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button
                                full="true"
                                text={translate('reopen', 'physical-confirmation')}
                                onClick={() => onClick()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reopen: (filter, callback) => {
            dispatch(PhysicalConfirmationService.reopen(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Reopen)));
